module.exports = __webpack_public_path__ + "static/media/empty.d5998ee38f92bd39f40a44184811249a.svg";